<template>
  <div class="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <img class="mx-auto h-16 w-auto" :src="require('@/assets/images/company_logo.png')" alt="회사 로고" />
      <h2 class="mt-6 text-center text-3xl font-bold text-gray-900">
        비밀번호 재설정
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        새로운 비밀번호를 입력해주세요
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-gray-200">
        <form class="space-y-6" @submit.prevent="handleSubmit">
          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              새 비밀번호
            </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LockIcon class="h-5 w-5 text-gray-400" />
              </div>
              <input id="password" name="password" :type="showPassword ? 'text' : 'password'" required
                v-model="password" :class="{ 'border-red-300': errors.password }"
                class="appearance-none block w-full pl-10 pr-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                placeholder="••••••••" />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button type="button" @click="togglePasswordVisibility" class="focus:outline-none">
                  <EyeIcon v-if="showPassword" class="h-5 w-5 text-gray-400" />
                  <EyeOffIcon v-else class="h-5 w-5 text-gray-400" />
                </button>
              </div>
            </div>
            <p v-if="errors.password" class="mt-2 text-sm text-red-600">{{ errors.password }}</p>
          </div>

          <div>
            <button type="submit" :disabled="isLoading"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              <LoaderIcon v-if="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" />
              <span v-if="isLoading">변경 중...</span>
              <span v-else>비밀번호 변경</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { LockIcon, EyeIcon, EyeOffIcon, LoaderIcon } from 'lucide-vue-next'
import { authAPI } from '@/api/apiClient'

const props = defineProps({
  branchCode: {
    type: String,
    required: true
  },
  verified: {
    type: Boolean,
    required: true
  },
  token: {
    type: String,
    required: true
  }
})

const router = useRouter()
const password = ref('')
const showPassword = ref(false)
const isLoading = ref(false)
const errors = reactive({
  password: ''
})

onMounted(() => {
  if (!props.verified) {
    router.push('/forgot-password')
  }
})

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

const handleSubmit = async () => {
  if (!password.value || password.value.length < 4) {
    errors.password = '비밀번호는 4자 이상이어야 합니다.'
    return
  }

  isLoading.value = true
  try {
    await authAPI.resetPassword(
      props.branchCode, 
      password.value, 
      props.token
    )
    router.push('/login')
  } catch (error) {
    if (error.response?.data) {
      const { message } = error.response.data
      errors.password = message
    } else {
      errors.password = '비밀번호 변경 중 오류가 발생했습니다.'
    }
  } finally {
    isLoading.value = false
  }
}
</script>